var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderHistory h100"},[_c('OrderList',{attrs:{"filters":_vm.filters,"filtersKey":_vm.filtersKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }